


































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
// import { CouponsManageAPI } from "@/common/api/couponList";
import AllinMerchantAccountAPI from '@/common/api/operationManage/allinMerchantAccountList';
import { excuteDownloadExport2Excel } from "@/common/xlsx";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import ZlSelect from "@/components/third-custom-components/select";

import ZlOption from "@/components/third-custom-components/option";

import {
  shareConfirmOptions,
  getCommonList
} from '@/common/config'

export const pageApiList = getPageAPIs(AllinMerchantAccountAPI)

const defaultForm = {
  province_name: '',
  brand_type: '', // 品牌类型 1熊猫 2麦力士/众享
  status: '', // 状态 0未使用 1使用中 2待确定 不传或空为全部
}


// 品牌类型 1熊猫 2麦力士/众享
const brandType2Ch: string[] = ['', '熊猫', '众享']


// 0未使用 1使用中 2待确定
const merchantAccountStatus2Ch: string[] = ['未使用', '使用中', '待确定']


// 类型：1开户 2备用
const accountType2Ch: string[] = ['', '开户', '备用']


const defaultForms = {
  brand_type: '', // 设备编码
  province_code: "",
  type: '',
  name: '', // 商户名称
  allin_merchant_number: '', // 商户号
  // singleMaxCountType: '0',
  // shop_id: "",
  // maxLimitCount: ''
};



// const deviceBoxType2ch: string[] = ['', '千鸣', '闪优']

// const defaultSearchVenuePageOption = {
//   page: 1,
//   limit: 10,
//   isRearchBottom: false,
// };

const allinMerchantAccountDialogModeDialogTitle2ch: any = {
  "new-allin-merchant-account": "新增",
  "edit-allin-merchant-account": "编辑",
};

// 最大有效期
// const maxExpiredDays = 9999;

// 最大时长 单位分钟
// const maxTimeDuration = 24 * 60;

const maxBenefitRate = 100

@Component({
  components: {
    ZlSelect,
    ZlOption,
  },
  filters: {
    // showDeviceTypeName(box_type: number) {
    //   return deviceBoxType2ch[box_type] || '未知'
    // }
    showAccountTypeName(type: number) {
      return accountType2Ch[type] || ''
    },
    showBrandTypeName(brand_type: number) {
      return brandType2Ch[brand_type] || ''
    },
    showAccountStatusName(status: number) {
      return merchantAccountStatus2Ch[status] || ''
    }
  }
})
export default class AllinMerchantAccount extends Vue {
  private form: any = {
    // allinMerchantAccountDialogModeId: "",
    // shop_name: "",
    // time: []
    // shop_id: '',
    // time: [],
    // startDate: "",
    // endDate: "",
  };
  private forms: any = {
    // maxType: "0",
    // ...defaultForms
  };

  private deepLoopUtil: any = {};

  private chooseMerchartAccountList: any[] = getCommonList(merchantAccountStatus2Ch, 0)

  private chooseBrandTypeList: any[] = getCommonList(brandType2Ch, 1)

  private chooseAccountTypeList: any[] = getCommonList(accountType2Ch, 1)

  // private deviceTypeList: any[] = getCommonList(deviceBoxType2ch, 1)

  // private merchantApi: any;

  private allinMerchantAccountApi = new AllinMerchantAccountAPI();

  // private allinMerchantAccountDialogModeTimeDurationAPI = new AllinMerchantAccountTimeDurationManageAPI();
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    };


    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    // this.searchVenuePageOption = {
    //   ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
    // };

    // this.merchantApi = new MerchantApi();
  }

  // private async handleChangeDeviceType(val: number) {
  //   const forms = {
  //     ...this.deepLoopUtil.deepCopy(this.forms, false),
  //   };

  //   Object.assign(forms, {
  //     cabinet_id: ''
  //   })
  //   // switch (val) {
  //   //   case 1: // 千鸣
        
  //   //     break;
  //   //   case 2: // 闪优
  //   //     await this.refreshSanyouDeviceList()
  //   //     break;
  //   // }

  //   this.forms = forms
  // }

  // private handleRefreshVenueDeviceInfo() {
  //   const forms = this.forms

  //   const {
  //     box_type
  //   } = forms

  //   // if (box_type == 2) {
  //   //   this.refreshSanyouDeviceList() 
  //   // }
  // }

  private chooseProvinceList: any[] = []

  private refreshProvinceList() {
    return new Promise((resolve, reject) => {
      this.allinMerchantAccountApi.getProviceList({}, (res: any) => {
        const {
          list = []
        } = res.data || {}

        this.chooseProvinceList = list

        resolve(list)
      }, (err: any) => {
        reject(err)
      })
    })
  }

  // private sanyouDeviceList: any[] = []

  // private refreshSanyouDeviceList() {
  //   const forms = this.forms

  //   const {
  //     venue
  //   } = forms || {}

  //   return new Promise((resolve, reject) => {
  //     if (venue && venue.id) {
  //       this.allinMerchantAccountApi.sanYouDevice({
  //         shop_id: venue.id
  //       }, (res: any) => {
  //         resolve(res.data)
  //         this.sanyouDeviceList = res.data
  //       }, (err: any) => {
  //         reject(err)
  //         console.log(err, 'err')
  //       })
  //     } else {
  //       reject()
  //       this.$message.error('请先选择店铺')
  //     }
  //   })

    
  // }

  
  private created(): void {
    this.getAllinMerchantAccounts();

    // this.refreshAllinMerchantAccountTimeDurations();

    // this.refreshTableClass();
  }
  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getAllinMerchantAccounts();
  }
  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getAllinMerchantAccounts();
  }

  private tableData: any[] = [];

  //dialog
  // private dialogFormVisible: boolean = false;
  private formLabelWidth: string = "100px";
  
  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getAllinMerchantAccounts();
  }

  private addOrUpdateAllinMerchantAccountTitle: string = "通联商户号";

  private dialogFormVisible: boolean = false;

  // 拉起通联商户号弹框
  private handleWakeAllinMerchantAccountDialog(mode: string) {
    // if (mode == 'new-allin-merchant-account') { // 新增通联商户号

    // }
    this.allinMerchantAccountDialogMode = mode;
    this.addOrUpdateAllinMerchantAccountTitle = allinMerchantAccountDialogModeDialogTitle2ch[mode] || "通联商户号";

    this.initAllinMerchantAccountForm(mode);

    this.dialogFormVisible = true;
  }

  private currentAllinMerchantAccountItem: any = null;

  private allinMerchantAccountDialogMode: string = "";

  private async initAllinMerchantAccountForm(mode: string) {
    const forms: any = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    await this.refreshProvinceList()

    if (mode == "edit-allin-merchant-account") {
      // 编辑
      // await this.getMoreVenueList(true);


      // await this.refreshAllinMerchantAccountTimeDurations();

      // await this.refreshTableClass();

      const currentAllinMerchantAccountItem = this.currentAllinMerchantAccountItem;

      const {
        id,
        province_code,
        brand_type,
        type,
        name,
        allin_merchant_number,
      } = currentAllinMerchantAccountItem || {};

      Object.assign(forms, {
        province_code: Number(province_code),
        brand_type,
        type,
        name: name || '',
        allin_merchant_number: allin_merchant_number || ''
      })

      // if (name && typeof shop_id == "number") {
      //   console.log(shop_id, "shop_id");

      //   console.log(this.venueList, "this.venueList");
      //   let existVenue = this.venueList.find((venue) => venue.id == shop_id);

      //   if (!existVenue) {
      //     existVenue = {
      //       id: shop_id,
      //       name: name,
      //     };
      //     this.venueList.push(existVenue);
      //   }

      //   forms.venue = existVenue;
      // }

      forms.id = id;
    }

    console.log(forms, "forms");

    // console.log(this.venueList, "this.venueList");

    this.forms = forms;

    // if (mode == "edit-allin-merchant-account") {
    //   await this.refreshSanyouDeviceList()
    // }
  }

  private handleWakeEditAllinMerchantAccountDialog(allinMerchantAccountItem: any) {
    this.currentAllinMerchantAccountItem = allinMerchantAccountItem;

    this.handleWakeAllinMerchantAccountDialog("edit-allin-merchant-account");
  }

  private onMarkAllinMerchantAccountDialog(allinMerchantAccountItem: any) {
    this.$confirm("是否确定将该商户号标记为未使用?", "标记", {
      ...shareConfirmOptions,
    }).then(() => {
      this.allinMerchantAccountApi.markAllinMerchantAccount({
        id: allinMerchantAccountItem.id
      }, () => {
        this.getAllinMerchantAccounts()
      }, () => {

      })
    });
  }

  private onUseAllinMerchantAccountDialog(allinMerchantAccountItem: any) {
    this.$confirm("是否确定将该商户号改为使用?", "使用", {
      ...shareConfirmOptions,
    }).then(() => {
      this.allinMerchantAccountApi.useAllinMerchantAccount({
        id: allinMerchantAccountItem.id
      }, () => {
        this.getAllinMerchantAccounts()
      }, () => {

      })
    });
  }



  // private venueList: any[] = [
  //   // {
  //   //   id: 1,
  //   //   label: '测试'
  //   // },
  //   // {
  //   //   id: 2,
  //   //   label: '测试2'
  //   // }
  // ];

  // private searchVenueLoading: boolean = false;

  // private remoteGetVenueQueryString: string = "";

  // private remoteSearchVenueTimer: any = null;

  // private searchVenuePageOption: any = {};

  // private initRemoteGetVenuePageOption() {
  //   this.searchVenuePageOption = {
  //     ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
  //   };
  // }

  // private getSearchVenueParams() {
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const remoteGetVenueQueryString = this.remoteGetVenueQueryString;

  //   const { page, limit } = searchVenuePageOption;

  //   const params: any = {
  //     page,
  //     limit,
  //   };

  //   if (remoteGetVenueQueryString && remoteGetVenueQueryString.trim()) {
  //     params.name = remoteGetVenueQueryString.trim();
  //   }

  //   return params;
  // }

  // private getMoreVenueList(refresh: boolean = true) {
  //   return new Promise((resolve: Function, reject: Function) => {
  //     if (refresh) {
  //       this.initRemoteGetVenuePageOption();
  //     }

  //     const params = this.getSearchVenueParams();

  //     this.allinMerchantAccountApi.searchVenueList(
  //       params,
  //       (res: any) => {
  //         console.log(res, "res");

  //         const venueList: any[] = res.data || [];

  //         this.venueList = refresh
  //           ? venueList
  //           : this.venueList.concat(venueList);

  //         if (Array.isArray(res.data) && res.data.length == 0) {
  //           this.searchVenuePageOption.isRearchBottom = true;
  //         }
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         resolve();
  //       },
  //       () => {
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         reject();
  //       }
  //     );
  //   });
  // }

  // // 第一次搜索 无关键字
  // private handleFirstGetVenueList() {
  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 清空搜索
  // private handleClearGetVenueList() {
  //   this.remoteGetVenueQueryString = "";

  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 远程搜索
  // private remoteGetVenueMethod(query: string) {
  //   query = query.trim ? query.trim() : "";

  //   if (query !== "") {
  //     this.remoteGetVenueQueryString = query;
  //     clearTimeout(this.remoteSearchVenueTimer);

  //     this.remoteSearchVenueTimer = setTimeout(() => {
  //       this.searchVenueLoading = true;

  //       this.getMoreVenueList();
        
  //     }, 300);
  //   } else {
  //     this.remoteGetVenueQueryString = "";
  //     this.venueList = [];
  //   }
  // }

  // private addVenueListLoading: boolean = false;

  // private remoteAddVenueMethod() {
  //   if (this.addVenueListLoading) return;
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const { isRearchBottom } = searchVenuePageOption;

  //   if (isRearchBottom) return;

  //   this.searchVenuePageOption.page++;

  //   this.addVenueListLoading = true;

  //   this.getMoreVenueList(false);
  // }

  // 分成比例
  // private handleLimitBenefitRate(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       const limit_val = Math.min(Number(new_val), maxBenefitRate).toString();
  //       this.$set(this.forms, "fencheng_rate", limit_val);
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "fencheng_rate", new_val);
  //     }
  //   );
  // }

  // private handleLimitSingleMaxCount(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       this.$set(this.forms, "maxLimitCount", new_val);
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "maxLimitCount", new_val);
  //     }
  //   );
  // }

  private sumbitAllinMerchantAccountLoading: boolean = false;

  // 提交通联商户号配置
  private handleSumbitAllinMerchantAccount() {
    const allinMerchantAccountDialogMode = this.allinMerchantAccountDialogMode;

    const params = this.getAllinMerchantAccountFormsParams(allinMerchantAccountDialogMode);

    console.log(params, "params");
    if (params === false) return;

    this.sumbitAllinMerchantAccountLoading = true;
    switch (allinMerchantAccountDialogMode) {
      case "new-allin-merchant-account":
        this.allinMerchantAccountApi.addAllinMerchantAccount(
          params,
          () => {
            this.getAllinMerchantAccounts();
            this.dialogFormVisible = false;
            this.sumbitAllinMerchantAccountLoading = false;
          },
          () => {
            this.sumbitAllinMerchantAccountLoading = false;
          }
        );
        break;
      case "edit-allin-merchant-account":
        this.allinMerchantAccountApi.updateAllinMerchantAccount(
          params,
          () => {
            this.getAllinMerchantAccounts();
            this.dialogFormVisible = false;
            this.sumbitAllinMerchantAccountLoading = false;
          },
          () => {
            this.sumbitAllinMerchantAccountLoading = false;
          }
        );
        break;
    }
  }

  private getAllinMerchantAccountFormsParams(mode: string) {
    const params: any = {};

    const showErrorMessage = (msg: string) => {
      if (!!msg) {
        this.$message.error(msg);
      }
    };

    const forms = this.forms;

    const {
      id,
      // name,
      // expired_days,
      // meituanId,
      // timeDuration
      // machine_number,
      cabinet_id,
    } = forms || {};

    

    const keys = ["brand_type", "province_code", "type", "name", "allin_merchant_number"];

    const key2EndKey: any = {
      brand_type: "brand_type",
      province_code: "province_code",
      type: "type",
      name: "name",
      allin_merchant_number: "allin_merchant_number"
    };

    const key2ErrMsg: any = {
      brand_type: "平台不能为空",
      province_code: "地区不能为空",
      type: "类型不能为空",
      name: "商户名称不能为空",
      allin_merchant_number: "商户号不能为空"

    };

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (forms[key]) {
        const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
        if (errMsg) {
          showErrorMessage(errMsg);

          return false;
        }
        params[key2EndKey[key] || key] = forms[key];
      } else {
        showErrorMessage(key2ErrMsg[key]);

        return false;
      }
    }
    

    if (mode == "edit-allin-merchant-account") {
      params.id = id;
    }

    return params;

  }

  //获取通联商户号列表
  private getAllinMerchantAccounts(): void {
    const params = this.getAllinMerchantAccountParams()
    this.allinMerchantAccountApi.getAllinMerchantAccountList(
      { ...params },
      (res: any) => {
        // res.data.list
        this.tableData = res.data.list;
        this.tablePage.page = res.data.page || params.page;
        this.tablePage.prepage = res.data.prepage || params.limit;
        // this.tablePage.totalPage = res.data.total;
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getAllinMerchantAccountParams(mode = "all"): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const { province_name, status, brand_type } = form;

    if (province_name) {
      params.province_name = province_name;
    }

    if (typeof status == 'number') {
      params.status = status;
    }

    if (brand_type) {
      params.brand_type = brand_type
    }

    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   params.start_date = startTime;

    //   params.end_date = endTime;
    // }

     if (
      mode == "exportExcel" &&
      !(params.start_date && params.end_date)
    ) {
      this.$message.error("请选择日期导出数据");
      return null;
    }



    if (mode === "all") {
      params.page = page;

      params.limit = prepage;

      // outerParams.__isUnique = !firstLoading;
    }

    return params;
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }

  /** 导出excel */
  // private downloadExcelLoading: boolean = false;

  // // 字段名 文案对应关系
  // private merchantExcelList2ch: any = {
  //   name: "店铺名称",
  //   shop_id: " 店铺ID",
  //   cabinet_id: "绑定设备ID",
  //   _device_type_name: "绑定设备类型",
  //   admin_name: "操作人",
  //   updated_at: "操作时间"
  // };
  // // 商户Excel 表头的先后顺序
  // private merchantExcelSortList: string[] = [
  //   "name",
  //   "shop_id",
  //   "cabinet_id",
  //   "_device_type_name",
  //   "admin_name",
  //   "updated_at"
  // ];

  // // 点击导出excel 表格
  // private handleExportExcelAllinMerchantAccountList() {
  //   const params = this.getAllinMerchantAccountParams('exportExcel')

  //   if (params === null) {
  //     return false;
  //   }

  //   this.downloadExcelLoading = true;
  //   this.allinMerchantAccountApi.exportExcelStoragelockerList(
  //     params,
  //     (res: any) => {
  //       const { start_date, end_date } = params || {};

  //       const filename = `通联商户号管理列表 ${start_date}到${end_date}.xlsx`;
  //       const { data } = res || {};

  //       const {
  //         list: originList
  //       } = data || {}

  //       const newList = Array.isArray(originList)
  //         ? originList.map((item) => {
  //             const { 
  //               // status,
  //               // back_goods_detail
  //               box_type
  //              } = item || {};
  //             const newItem = {
  //               ...(item || {}),
  //               // __status_text: withdrawAccountAudit2Text[status],
  //               // __back_good_details: back_goods_detail.map((goods: any, index: number) => `${ goods.name }x${ goods.num }  ¥${ goods.price }`).join('; \t')
  //               _device_type_name: deviceBoxType2ch[box_type] || '未知'
  //             };

  //             for (let key in item) {
  //               if (typeof item[key] == 'number') {
  //                 newItem[key] = item[key].toString()
  //               }
  //             }

             
  //             return newItem;
  //           })
  //         : [];

  //       if (newList.length > 0) {
  //         const merchantExcelSortList = this.merchantExcelSortList;

  //         const merchantExcelList2ch = this.merchantExcelList2ch;

  //         const excelJSONData = getExcelJSONDataByList(
  //           newList,
  //           merchantExcelSortList,
  //           merchantExcelList2ch
  //         );

  //         excuteDownloadExport2Excel(excelJSONData, filename);
  //       } else {
  //         this.$message.info("选中时段没有可导出的信息");
  //       }

  //       this.downloadExcelLoading = false;
  //     },
  //     () => {
  //       this.downloadExcelLoading = false;
  //     }
  //   );
  // }

  /** end 导出excel */

  private selectPage: any = {
    page: 1,
    prepage: 200,
    totalPage: 0,
    count: 0,
  };
}
